let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fddWJ")).then(() => parcelRequire('cr3aG'));